export default "__VITE_ASSET__Bvlq3GcB__"